import React from 'react';
import PortfolioProjects from '../portfolio/PortfolioProjects.jsx';

const PortfoliosList = ({
  portfolios,
  projects,
  projectStatuses,
  queryState,
  onDeleteProject,
  onDeletePortfolio,
  isTopLevel,
}) => {
  const filteredPortfolios = portfolios.filter((p) => p.id !== 'no_portfolio');

  return (
    <React.Fragment>
      {filteredPortfolios.map((portfolio) => (
        <PortfolioProjects
          key={portfolio.id}
          portfolio={portfolio}
          queryState={queryState}
          organizationProjects={projects}
          projectStatuses={projectStatuses}
          onDeleteProject={onDeleteProject}
          onDeletePortfolio={onDeletePortfolio}
          isTopLevel={isTopLevel}
        />
      ))}
    </React.Fragment>
  );
};

export default PortfoliosList;
